/** Backend error_code for compute-hours quota exhaustion (subscription middleware). */
export const COMPUTE_HOURS_EXHAUSTED = 'compute_hours_exhausted';
